"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bg = bg;
exports.borderColor = borderColor;
exports.borderRadius = borderRadius;
exports.borderWidth = borderWidth;
exports.cleanComponentProps = void 0;
exports.cleanProps = cleanProps;
exports.color = color;
exports.cssValue = cssValue;
exports.default = void 0;
exports.display = display;
exports.fontSize = fontSize;
exports.height = height;
exports.lineHeight = lineHeight;
exports.margin = void 0;
exports.minHeight = minHeight;
exports.minWidth = minWidth;
exports.padding = exports.omitDefaults = void 0;
exports.shadow = shadow;
exports.space = space;
exports.spacing = spacing;
exports.tailored = tailored;
exports.textAlign = textAlign;
exports.width = width;
exports.withDefaultProps = withDefaultProps;
exports.withProps = withProps;
exports.withTheme = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styles = require("@material-ui/core/styles");
var materialColors = _interopRequireWildcard(require("@material-ui/core/colors"));
var _lodash = require("lodash");
var _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const colorAlias = {
  facebook: '#3B5998'
};
const withTheme = exports.withTheme = _styles.withTheme;
function cleanProps(props) {
  let approvedProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const res = approvedProps.reduce((a, n) => {
    return n && props[n] ? _objectSpread(_objectSpread({}, a), {}, {
      [n]: props[n]
    }) : a;
  }, {});
  return res;
}
function withProps(providedProps, Wrapped) {
  return function () {
    for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
      props[_key] = arguments[_key];
    }
    return /*#__PURE__*/_react.default.createElement(Wrapped, _extends({}, providedProps, props));
  };
}
function withDefaultProps(defaultProps, Wrapped) {
  const WithDefaultPropsComponent = props => /*#__PURE__*/_react.default.createElement(Wrapped, _objectSpread(_objectSpread({}, defaultProps), props));
  return WithDefaultPropsComponent;
}
function sizeStyles(property, styles) {
  return styles && (props => {
    const result = [];
    if (Array.isArray(styles)) {
      const breakpoints = Object.values(props.theme.breakpoints.values);
      // Media Query
      result.push(...styles.map((val, key) => val && `
        @media(min-width: ${breakpoints[key] || 0}px) {
          ${property}: ${Number.isNaN(val.toString().substr(-1)) ? val : `${val}px`};
        }
      `));
    } else {
      result.push(`${property}: ${Number.isNaN(styles.toString().substr(-1)) ? styles : `${styles}px`}`);
    }
    return result.join('\n');
  });
}
function spacing(key) {
  // eslint-disable-next-line complexity
  return props => {
    const config = {};
    if (key === 'padding') {
      config.t = props.p || props.py || props.pt || null;
      config.r = props.p || props.px || props.pr || null;
      config.b = props.p || props.py || props.pb || null;
      config.l = props.p || props.px || props.pl || null;
    } else {
      config.t = props.m || props.my || props.mt || null;
      config.r = props.m || props.mx || props.mr || null;
      config.b = props.m || props.my || props.mb || null;
      config.l = props.m || props.mx || props.ml || null;
    }
    return (0, _styledComponents.css)`
      ${sizeStyles(`${key}-top`, config.t)};
      ${sizeStyles(`${key}-right`, config.r)};
      ${sizeStyles(`${key}-bottom`, config.b)};
      ${sizeStyles(`${key}-left`, config.l)};
    `;
  };
}
const padding = exports.padding = spacing('padding');
const margin = exports.margin = spacing('margin');
function space() {
  const result = (0, _styledComponents.css)`
    ${padding};
    ${margin};
  `;
  return result;
}
function cssValue(key, value) {
  return value && (0, _styledComponents.css)`
      ${key}: ${value};
    `;
}
function minHeight(props) {
  return cssValue('min-height', props.minHeight);
}
function minWidth(props) {
  return cssValue('min-width', props.minWidth);
}
function textAlign(props) {
  return cssValue('text-align', props.textAlign);
}
function width(props) {
  return cssValue('width', props.width);
}
function height(props) {
  return cssValue('height', props.height);
}
function lineHeight(props) {
  return cssValue('line-height', props.lineHeight);
}
function fontSize(props) {
  return cssValue('font-size', props.fontSize);
}
function display(props) {
  if (!Object.keys(props).includes('display', 'inline', 'block', 'inline-block', 'flex', 'inline-flex')) {
    return '';
  }
  return cssValue('display', props.block && 'block' || props.inlineFlex && 'inlineFlex' || props.display);
}
function shadow(props) {
  return props.shadow && (0, _styledComponents.css)`
      box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.03);
    `;
}
function bg(props) {
  if (!props.bg) {
    return '';
  }
  const [clr, hue = 500] = (colorAlias[props.bg] || props.bg).split(' ');
  return (0, _styledComponents.css)`
    background-color: ${materialColors[clr] ? materialColors[clr][hue] : clr};
  `;
}
function color(props) {
  if (!props.color) {
    return '';
  }
  const [clr, hue = 500] = (colorAlias[props.color] || props.color).split(' ');
  return (0, _styledComponents.css)`
    color: ${materialColors[clr] ? materialColors[clr][hue] : clr};
  `;
}
function borderRadius(props) {
  return cssValue('border-radius', props.borderRadius);
}
function borderColor(props) {
  return cssValue('border-color', props.borderColor);
}
function borderWidth(props) {
  return cssValue('border-width', props.borderWidth);
}
const omitDefaults = exports.omitDefaults = ['theme', 'mt', 'mb', 'mr', 'ml', 'mx', 'my', 'p', 'pt', 'pl', 'pr', 'px', 'py', 'fontSize', 'color', 'fullWidth', 'float'];
function tailored(Wrapped) {
  let styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  let propNames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return (0, _styledComponents.default)(props => /*#__PURE__*/_react.default.createElement(Wrapped, cleanProps(props, [...propNames, 'children', 'className'])))`
    ${styles};
    ${space};
    ${minWidth};
    ${minHeight};
    ${textAlign};
    ${width};
    ${height};
    ${lineHeight};
    ${fontSize};
    ${display};
    ${shadow};
    ${bg};
    ${color};
    ${borderRadius};
    ${borderColor};
    ${borderWidth};
  `;
}
const cleanComponentProps = function (ComposedComponent) {
  let propsToOmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return /*#__PURE__*/_react.default.createElement(ComposedComponent, (0, _lodash.omit)(_this.props, propsToOmit));
};
exports.cleanComponentProps = cleanComponentProps;
var _default = exports.default = cleanComponentProps;
//# sourceMappingURL=styled.js.map